

class UploadStates {
    static IDLE = Symbol("IDLE");
    static UPLOADING = Symbol("UPLOADING");
    static FINISHED_UPLOAD = Symbol("FINISHED_UPLOAD");
    static FAILED_UPLOAD = Symbol("FAILED_UPLOAD");
}
export default UploadStates;
